import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FileDown, ShieldCheck, Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function RecordsDownloadPage() {
    const { token } = useParams();
    const url = `${BACKEND}/api/records/download/${token}`;
    const [started, setStarted] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => { window.location.href = url; setStarted(true); }, 600);
        return () => clearTimeout(t);
    }, [url]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" data-testid="records-download-page">
            <div className="bg-white rounded-3xl shadow-xl p-8 max-w-md w-full text-center space-y-4">
                <span className="w-14 h-14 mx-auto rounded-2xl bg-phoenix-navy text-white flex items-center justify-center"><FileDown className="w-7 h-7" /></span>
                <h1 className="font-display font-bold text-2xl text-phoenix-navy">Your medical records</h1>
                <p className="text-sm text-muted-foreground">
                    {started ? "Your download should begin automatically." : "Preparing your secure download…"}
                </p>
                <a href={url} data-testid="records-download-btn"
                    className="inline-flex items-center justify-center gap-2 w-full py-3 bg-phoenix-navy text-white font-semibold rounded-xl hover:bg-phoenix-navy-2 transition-all">
                    <FileDown className="w-4 h-4" /> Download records (PDF)
                </a>
                <p className="text-xs text-muted-foreground flex items-center justify-center gap-1.5">
                    <ShieldCheck className="w-3.5 h-3.5" /> This link is private and expires in 14 days.
                </p>
            </div>
        </div>
    );
}
